/* eslint-disable react/jsx-no-target-blank */
import Swal from 'sweetalert2';
import { useAuth } from '../../../../app/modules/auth'

const SidebarFooter = () => {

  const { logout } = useAuth();

  const confirmExit = async () => {

    await Swal.fire({
      text: "Deseja sair da aplicação!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      customClass: {
        confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
        cancelButton: 'btn btn-secondary' // Classe personalizada para o botão de cancelamento (opcional)
      }
    }).then((result) => {
      if (result.isConfirmed) {
        logout()
      }
    })
  }


  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      <span
        role="button"
        className='btn btn-flex flex-center btn-custom btn-danger overflow-hidden text-nowrap px-0 h-40px w-100'
        onClick={()=>confirmExit()}
      >
        <span  className='btn-label'>Sair</span>
      </span>
    </div>
  )
}

export {SidebarFooter}
